import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { reverIntegrationQuery } from "modules/settings/lib/rever/reverIntegrationQuery"
import {
  CreateIntegrationConfigurationSchema,
  DataResponse,
  UpsertReverIntegrationSchema,
} from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof CreateIntegrationConfigurationSchema>>

export function useUpsertReverIntegrationMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: z.infer<typeof UpsertReverIntegrationSchema>) => {
      const response = await axios.post<Response>(`/integrations/rever/configuration`, data)

      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: reverIntegrationQuery().queryKey })
    },
  })
}
